import { render, staticRenderFns } from "./Step9.vue?vue&type=template&id=1e9cb970&scoped=true&"
import script from "./Step9.vue?vue&type=script&lang=js&"
export * from "./Step9.vue?vue&type=script&lang=js&"
import style0 from "./Step9.vue?vue&type=style&index=0&id=1e9cb970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9cb970",
  null
  
)

export default component.exports